module.exports = __webpack_public_path__ + "static/img/player-bg.63b2b579.png";